import { EntryFilter, ApiEntryFilters } from 'api/data/filters';
import { parseApiEntryFilters } from './parseApiEntryFilters';
import {
	buildAggregationRuleNameToAggregatorVariableMap,
	buildVariablesDataFromStoreData
} from 'helpers/variables';
import { StoreVariablesData, VariablesMap } from 'store/data/variables';

/**
 * Builds the API filter payload for the active dataset filter from the legacy variables
 * store data and the active filter list. Aggregation-rule variables are injected into the
 * variables map so filters on aggregation rules resolve. Shared by the dataset/series
 * exports and the codelist export so they all apply the same active dataset filter.
 */
export function getActiveDatasetApiFilters(
	variablesStoreData: StoreVariablesData,
	activeFilters: EntryFilter[]
): ApiEntryFilters {
	const { variableSetsMap, variablesMap } = buildVariablesDataFromStoreData(variablesStoreData);

	const ruleNameToRuleMap = buildAggregationRuleNameToAggregatorVariableMap(variableSetsMap);

	const ruleNameToAggVarMap = Object.entries(ruleNameToRuleMap).reduce<VariablesMap>(
		(acc, [ruleName, rule]) => {
			acc[ruleName] = variablesMap[rule.aggregator.variableName];
			return acc;
		},
		{}
	);

	const injectedAggRuleVariablesMap = {
		...variablesMap,
		...ruleNameToAggVarMap
	};

	// The BE model does not support the "invalid" key, so strip it from each filter.
	const filtersWithoutInvalid = activeFilters.map(filter => {
		const { invalid, ...rest } = filter;
		return rest;
	});

	return parseApiEntryFilters(filtersWithoutInvalid, injectedAggRuleVariablesMap);
}
